import { render, staticRenderFns } from "./detail-contact.vue?vue&type=template&id=1c5f6aab&scoped=true"
import script from "./detail-contact.vue?vue&type=script&lang=js"
export * from "./detail-contact.vue?vue&type=script&lang=js"
import style0 from "./detail-contact.vue?vue&type=style&index=0&id=1c5f6aab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f6aab",
  null
  
)

export default component.exports